import { OnlyNumbersMask } from "react-masked-text/src/masks/only-numbers.mask";

const onlyNumbers = (value) => {
  const onlyNumbers = new OnlyNumbersMask();
  return onlyNumbers.getRawValue(value.trim());
};

export { onlyNumbers };
